if (!customElements.get('product-modal')) {
  const deferredMediaSelector = 'img[data-ohli-pdp-media-deferred]';

  const materializeMedia = (root) => {
    if (!root) return;
    const images = [];
    if (root.matches?.(deferredMediaSelector)) images.push(root);
    root.querySelectorAll?.(deferredMediaSelector).forEach((image) => images.push(image));
    images.forEach((image) => {
      image.loading = 'eager';
      if (image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
      if (image.dataset.src) image.setAttribute('src', image.dataset.src);
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.removeAttribute('data-ohli-pdp-media-deferred');
      image.removeAttribute('hidden');
    });
  };

  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        materializeMedia(activeMedia);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
